import React, { Component } from 'react';
import TextField from '../base/TextField';

class FullName extends Component {
  render() {
    return (
      <div className="form-fullname-row">
        <TextField label="First Name"
          name="info_first_name"
          className={['form-item-first-name']} />
        <TextField label="MI"
          name="info_initial"
          className={['form-item-initial']} />
        <TextField label="Last Name"
          name="info_last_name"
          className={['form-item-last-name']} />
      </div>
    )
  }
}

export default FullName;
